import { createReducer, on } from '@ngrx/store';
import {
  ProjectJobServiceCreateResponseJson,
  ProjectPermitTaskServiceCreateResponseJson,
  ProjectServiceCreateResponseJson,
  ProjectSurveyTaskServiceCreateResponseJson,
} from '@vmspdb/definitions';
import * as ProjectDetailsActions from './project-details.actions';

export const projectDetailsFeatureKey = 'projectDetails';

export interface State {
  project?: ProjectServiceCreateResponseJson;
  jobs: ProjectJobServiceCreateResponseJson[];
  permits: ProjectPermitTaskServiceCreateResponseJson[];
  surveys: ProjectSurveyTaskServiceCreateResponseJson[];
}

export const initialState: State = {
  jobs: [],
  permits: [],
  surveys: [],
};

export const reducer = createReducer(
  initialState,
  // Load main project data
  on(ProjectDetailsActions.loadProjectDetails, (state) => state),
  on(ProjectDetailsActions.loadProjectDetailsSuccess, (state, action) => ({
    ...state,
    project: action.data,
  })),
  on(ProjectDetailsActions.loadProjectDetailsFailure, (state) => ({
    ...state,
    project: undefined,
  })),
  // Jobs
  on(ProjectDetailsActions.loadProjectDetailsJobs, (state) => state),
  on(ProjectDetailsActions.loadProjectDetailsJobsSuccess, (state, action) => ({
    ...state,
    jobs: action.data,
  })),
  on(ProjectDetailsActions.loadProjectDetailsJobsFailure, (state) => ({
    ...state,
    jobs: [],
  })),
  // Permits
  on(ProjectDetailsActions.loadProjectDetailsPermits, (state) => state),
  on(
    ProjectDetailsActions.loadProjectDetailsPermitsSuccess,
    (state, action) => ({
      ...state,
      permits: action.data,
    }),
  ),
  on(ProjectDetailsActions.loadProjectDetailsPermitsFailure, (state) => ({
    ...state,
    permits: [],
  })),
  // Surveys
  on(ProjectDetailsActions.loadProjectDetailsSurveys, (state) => state),
  on(
    ProjectDetailsActions.loadProjectDetailsSurveysSuccess,
    (state, action) => ({
      ...state,
      surveys: action.data,
    }),
  ),
  on(ProjectDetailsActions.loadProjectDetailsSurveysFailure, (state) => ({
    ...state,
    surveys: [],
  })),
  // Reset
  on(ProjectDetailsActions.clearProjectDetails, () => ({
    ...initialState,
  })),
);
